import { HttpService } from "@core/services/http.service.ts";
import { apiURL } from "@utils/environment.ts";
import { CommuneDTO, DistrictDTO, FokontanyDTO, PaginateResponse, RegionDTO } from "@utils/appUtils.ts";

export class LocalisationService extends HttpService {
  private APIURL = apiURL;

  getAllRegion(params: {
    page: number;
    size: number;
    sortBy?: string;
    sortDir?: string;
    search?: string;
  }): Promise<PaginateResponse<RegionDTO>> {
    const queryParams = new URLSearchParams({
      page: params.page.toString(),
      size: params.size.toString(),
      sortBy: params.sortBy?.toString() || "",
      sortDir: params.sortDir?.toString() || "",
      search: params.search?.toString() || "",
    });
    this.urlAPI = this.APIURL + `/region?${queryParams}`;
    return this.doGet<PaginateResponse<RegionDTO>>();
  }

  getDistrict(params: {
    page: number;
    size: number;
    sortBy?: string;
    sortDir?: string;
    region?: string;
    search?: string;
  }): Promise<PaginateResponse<DistrictDTO>> {
    const queryParams = new URLSearchParams({
      page: params.page.toString(),
      size: params.size.toString(),
      sortBy: params.sortBy || "",
      sortDir: params.sortDir || "",
      region: params.region || "",
      search: params.search || "",
    });

    this.urlAPI = `${this.APIURL}/district?${queryParams}`;
    return this.doGet<PaginateResponse<DistrictDTO>>();
  }

  getCommune(params: {
    page: number;
    size: number;
    sortBy?: string;
    sortDir?: string;
    district?: string;
    search?: string;
  }): Promise<PaginateResponse<CommuneDTO>> {
    const queryParams = new URLSearchParams({
      page: params.page.toString(),
      size: params.size.toString(),
      sortBy: params.sortBy || "",
      sortDir: params.sortDir || "",
      district: params.district || "",
      search: params.search || "",
    });

    this.urlAPI = `${this.APIURL}/municipality?${queryParams}`;
    return this.doGet<PaginateResponse<CommuneDTO>>();
  }

  getFokontanys(params: {
    page: number;
    size: number;
    sortBy?: string;
    sortDir?: string;
    commune?: string;
    search?: string;
  }): Promise<PaginateResponse<FokontanyDTO>> {
    const queryParams = new URLSearchParams({
      page: params.page.toString(),
      size: params.size.toString(),
      sortBy: params.sortBy || "",
      sortDir: params.sortDir || "",
      commune: params.commune || "",
      search: params.search || "",
    });

    this.urlAPI = `${this.APIURL}/fokontany?${queryParams}`;
    return this.doGet<PaginateResponse<FokontanyDTO>>();
  }  
}
